export const otherFilterOptions = [
  {
    title: 'Format',
    counter: 0,
    optionItems: [
      { label: 'image', value: false },
      { label: 'video', value: false },
    ],
  },
  {
    title: 'Status',
    counter: 0,
    optionItems: [
      { label: 'live', value: false },
      { label: 'not_live', value: false },
    ],
  },
  {
    title: 'Ad Layout',
    counter: 0,
    optionItems: [
      { label: '9:16', displayName: '9:16 (Portrait / Story)', value: false },
      { label: '16:9', displayName: '16:9 (Landscape)', value: false },
      { label: '4:5', displayName: '4:5 (Vertical Feed)', value: false },
      { label: '5:4', displayName: '5:4 (Horizontal Feed)', value: false },
      { label: '1:1', displayName: '1:1 (Square)', value: false },
    ],
  },
  {
    title: 'Time Live',
    counter: 0,
    optionItems: [
      { label: 'under_7_days', value: false },
      { label: 'over_7_days', value: false },
      { label: 'over_30_days', value: false },
      { label: 'over_3_months', value: false },
      { label: 'over_6_months', value: false },
      { label: 'over_12_months', value: false },
    ],
  },
]
